<script>
import {environment} from '@app/store/envStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import firebase from '@app/configs/firebase.js';
import db from '@app/configs/firestore.js';
import { createEventDispatcher } from 'svelte';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();

async function addToTemplates() {
    try {
        if (eventGroupState[projectState.selected].selected.length > 0) {            
            let eventTemplate = JSON.parse(JSON.stringify(eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]]));
            eventTemplate.start = false;
            eventTemplate.end = false;
            eventTemplate.duration = false;
            eventTemplate.original = "";
            eventTemplate.speakers = [];
            eventTemplate.audioFile = ""; //We don't want to store blob data in DB
            eventTemplate.audioFileDuration = false;
            eventTemplate.waveformFile = "";
            eventTemplate.peaksData = [];
            eventTemplate.peaksSampleRate = 0;

            // Refactor to use local storage instead of firebase when environment.online is set to false

            if (environment.online){
                    let userId = firebase.auth().currentUser.uid;
                    db.collection("users").doc(userId).collection('templates').doc(eventTemplate.id).set(eventTemplate).then(() => {

                    toast.push(m.context_menu_event_template_created(), {classes: ["toast-success"]});

                }).catch((err) => {
                    console.log("Error creating event template: ", err, err.message);

                    toast.push(m.context_menu_event_template_error(), {classes: ["toast-danger"]});
                });
            } else {
                let templates = JSON.parse(localStorage.getItem('cc-event-templates'));
                if (!templates){
                    templates = [];
                }

                templates.push(eventTemplate);
                localStorage.setItem('cc-event-templates', JSON.stringify(templates));

                toast.push(m.context_menu_event_template_created(), {classes: ["toast-success"]});
            }
            
        }
    } catch(err){
        console.log(err, err.message);

        toast.push(m.context_menu_event_template_error(), {classes: ["toast-danger"]});
        
    } finally{
        dispatch("done");
    }
}
</script>

<a id="btnAddToTemplates"
   role="menuitem"
    aria-label={m.context_menu_event_template_label()}
   aria-disabled={eventGroupState.length === 0 || eventGroupState[projectState.selected].selected.length === 0}
   class="dropdown-item {eventGroupState.length === 0 || eventGroupState[projectState.selected].selected.length === 0 ? 'disabled' : ''}"
   href="#!/"
   onclick={addToTemplates}>
    {m.context_menu_event_template()}
</a>
